import { EmptyState } from '@payaca/ambrosia';
import { FC } from 'react';

export const InvoicesEmptyState: FC = () => {
  return (
    <EmptyState
      iconName="file-04"
      text={
        <div className="text-center">
          <p>No customer invoices yet.</p>
        </div>
      }
    />
  );
};
